

































import { MensagemProntaService } from "@/services/mensagem-pronta.service";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";

@Component({
  components: {
    Modal,
  },
})
export default class AlterarMensagemPronta extends Vue {
  idMensagemPronta: number | null = null;
  idMensagemOcta = "";
  titulo = "";
  rules = {
    idMensagemOcta: [required()],
    titulo: [required()],
  };
  loading = false;

  abrirModal(idMensagemPronta: number): Promise<boolean> {
    const modal = this.$refs.modal as Modal;

    this.idMensagemPronta = idMensagemPronta;
    this.idMensagemOcta = "";
    this.titulo = "";

    const p = modal.open();

    return this.fetchCanalLead(idMensagemPronta).then(() => p);
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    const p = modal.close(false);
    return p;
  }

  fetchCanalLead(id: number): Promise<void> {
    this.loading = true;
    return MensagemProntaService.obter(id)
      .then((mensagemPronta) => {
        this.titulo = mensagemPronta.tituloMensagem;
        this.idMensagemOcta = mensagemPronta.idMensagemOcta;
      })
      .finally(() => (this.loading = false));
  }

  salvar() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.loading = true;
      MensagemProntaService.manterMensagemPronta({
        idMensagemPronta: this.idMensagemPronta!,
        idMensagemOcta: this.idMensagemOcta,
        tituloMensagem: this.titulo,
      })
        .then(() => this.onCadastroSuccess(this.idMensagemPronta!))
        .finally(() => (this.loading = false));
    }
  }

  @Emit("onCadastroSuccess")
  onCadastroSuccess(idMensagemPronta: number) {
    const modal = this.$refs.modal as Modal;
    modal.close(!!idMensagemPronta);
  }
}
